import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Autosuggest from 'react-autosuggest';

import Avatar from '@mui/material/Avatar';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import ResetIcon from '@mui/icons-material/Cancel';
import InputAdornment from '@mui/material/InputAdornment';

import LockIcon from '@mui/icons-material/Lock';

import debounce from 'lodash/debounce';

import { MarcheType } from 'constants.js';
import { CompteEtat } from 'constants.js';

const MinimalLength = 2;

const styles = {
    container: {
        flexGrow: 1,
        position: 'relative'
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 2,
        marginTop: 10,
        maxHeight: '200px',
        overflowY: 'auto',
        backgroundColor: '#fff',
        border: '1px solid #aaa'
    },
    suggestion: {
        display: 'block'
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none'
    }
};

class ClientSearch extends React.Component {
    state = {
        isLoading: false
    };

    componentDidMount() {
        const { onSuggestionSelected, client } = this.props;

        // Si les infos logistiques sont renseignées alors on pré-sélectionne le client
        if (client) {
            onSuggestionSelected(client);
        }
    }

    handleSuggestionsFetchRequested = debounce(({ value }) => {
        if (value.length >= MinimalLength) {
            const { onSearch } = this.props;

            this.setState({
                isLoading: true
            });

            onSearch(value);

            this.setState({
                isLoading: false
            });
        }
    }, 300);

    handleSuggestionsClearRequested = () => {
        const { onClear } = this.props;

        onClear();
    };

    handleChange = (event, { newValue }) => {
        const { onChange } = this.props;

        // Pour gérer le cas où l'on descend dans la zone de choix avec les flèches.

        if (Object.prototype.toString.call(newValue) === "[object String]") {
            onChange(newValue);
        }
        else {
            onChange(event.target.value);
        }

    };

    handleSuggestionSelected = (event, { suggestion }) => {
        const { onSuggestionSelected } = this.props;

        onSuggestionSelected(suggestion);
    }

    handleBlur = () => {
        const { onSuggestionSelected, selectedId } = this.props;

        if (selectedId === 0) {
            onSuggestionSelected({ id: 0, code: '', libelle: '' });
        }
    };

    handleClickReset = () => {
        const { onSuggestionSelected } = this.props;
        onSuggestionSelected({ id: 0, code: '', libelle: '' });
    }

    getSuggestionValue = (suggestion) => {
        return suggestion.code + " - " + suggestion.libelle;
    }


    renderInput = inputProps => {
        const { classes, ref, disabled, onClickReset, ...other } = inputProps;
        const { isRequired, error, autoFocus, client, size } = this.props;

        let BadgeMarche = () => {

            if (disabled && client && client.marcheType === MarcheType.Prive) {
                return <Avatar sx={{
                    marginLeft: 1,
                    marginRight: 1,
                    width: 24,
                    height: 24,
                    fontSize: '0.50rem',
                    backgroundColor: 'client.marche.prive',
                    border: "1px solid black",
                    boxShadow: 2
                }}>MPR</Avatar>;
            }

            if (disabled && client && client.marcheType === MarcheType.Public) {
                return <Avatar sx={{
                    marginLeft: 1,
                    marginRight: 1,
                    width: 24,
                    height: 24,
                    fontSize: '0.50rem',
                    backgroundColor: 'client.marche.public',
                    border: "1px solid black",
                    boxShadow: 2
                }}>MPU</Avatar>;
            }
            // MarcheType.HorsMarche
            return null;
        };

        return (
            <TextField
                fullWidth
                required={isRequired}
                error={error !== undefined}
                label="Client"
                size={size}
                placeholder="Rechercher un client"
                helperText={error ? error.errorMsg : ''}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                    inputRef: ref,
                    classes: { input: classes.input },
                    disabled,
                    endAdornment: disabled && (!client || (client && !client.verrou)) && (
                        <InputAdornment position={'end'}>
                            <IconButton onClick={onClickReset} size="large"><ResetIcon /></IconButton>
                        </InputAdornment >
                    ),
                    startAdornment: disabled && (
                        <InputAdornment position={'start'}>
                            {client && client.etat === CompteEtat.Ferme && (<LockIcon />)}
                            <BadgeMarche />
                        </InputAdornment >
                    ),
                    sx: { fontStyle: disabled && client && client.etat === CompteEtat.Ferme ? 'italic' : '' },
                    ...other
                }}
                autoFocus={autoFocus}
            />
        );
    }

    renderSuggestionsContainer(options) {
        const { containerProps, children } = options;

        return (
            <div {...containerProps} >
                {children}
            </div>
        );
    }

    renderSuggestion(suggestion, { isHighlighted }) {

        let BadgeMarche = () => {

            if (suggestion.marcheType === MarcheType.Prive) {
                return <Avatar sx={{
                    marginLeft: 1,
                    marginRight: 1,
                    width: 24,
                    height: 24,
                    fontSize: '0.50rem',
                    backgroundColor: 'client.marche.prive',
                    border: "1px solid black",
                    boxShadow: 2
                }}>MPR</Avatar>;
            }

            if (suggestion.marcheType === MarcheType.Public) {
                return <Avatar sx={{
                    marginLeft: 1,
                    marginRight: 1,
                    width: 24,
                    height: 24,
                    fontSize: '0.50rem',
                    backgroundColor: 'client.marche.public',
                    border: "1px solid black",
                    boxShadow: 2
                }}>MPU</Avatar>;
            }
            // MarcheType.HorsMarche
            return null;
        };


        let BadgeEtat = () => {

            if (suggestion.etat === CompteEtat.Ferme) {
                return <LockIcon />;
            }

            return null;
        };

        return (
            <MenuItem selected={isHighlighted} component="div" >

                <span style={{ fontStyle: suggestion.etat === CompteEtat.Ferme ? 'italic' : '' }}>{suggestion.code} - {suggestion.libelle}</span> <BadgeEtat />  <BadgeMarche />

            </MenuItem>
        );
    }

    render() {
        const { classes, clients, selectedId, client } = this.props;

        return (
            <Autosuggest
                theme={{
                    container: classes.container,
                    suggestionsContainerOpen: classes.suggestionsContainerOpen,
                    suggestionsList: classes.suggestionsList,
                    suggestion: classes.suggestion
                }}
                renderInputComponent={this.renderInput}
                suggestions={clients}
                onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
                renderSuggestionsContainer={this.renderSuggestionsContainer}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                onSuggestionSelected={this.handleSuggestionSelected}
                inputProps={{
                    classes,
                    value: this.props.value,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    disabled: selectedId !== 0,
                    onClickReset: this.handleClickReset
                }}
            />
        );
    }
}

ClientSearch.propTypes = {
    clients: PropTypes.array.isRequired,
    onSearch: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    isRequired: PropTypes.bool.isRequired,
    error: PropTypes.object,
    onSuggestionSelected: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    selectedId: PropTypes.number.isRequired,

    autoFocus: PropTypes.bool.isRequired,
    size: PropTypes.string,
    client: PropTypes.object,
};


export default withStyles(styles)(ClientSearch);